import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Overview from './pages/Overview';
import Strategies from './pages/Strategies';
import Decisions from './pages/Decisions';
import Trades from './pages/Trades';
import GymData from './pages/GymData';
import GymBacktests      from './pages/GymBacktests';
import GymBacktestDetail from './pages/GymBacktestDetail';
import Monitor from './pages/Monitor';

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/"            element={<Overview />}    />
          <Route path="/strategies"  element={<Strategies />}  />
          <Route path="/decisions"   element={<Decisions />}   />
          <Route path="/trades"      element={<Trades />}      />
		  <Route path="/gym"      element={<GymData />}      />
		  <Route path="/gym/backtests"     element={<GymBacktests />}      />
		  <Route path="/gym/backtests/:id" element={<GymBacktestDetail />} />

		  <Route path="/monitor" element={<Monitor />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}